export default __webpack_public_path__ + "static/media/medalha-platina.7cc0e793.svg";